module.exports = __webpack_public_path__ + "img/L_323_327.3ad7a78e.png";